import{useCallback as n}from"react";import s from"./use-event";const d=e=>{const o=n(t=>{t.code==="Escape"&&e()},[e]);s("keydown",o)};var p=d;export{p as default};
//# sourceMappingURL=use-escape.js.map
